import axios from 'axios'
import Vue from 'vue'
import VueRouter from '../router'
import { Toast } from 'vant'

const instance = axios.create({
    baseURL: '/api/cusapi/', // api 的 base_url
    timeout: 10000, // request timeout
    headers: { 'Content-Type': 'application/json' }
})

function UrlSearch() {
    var name, value;
    var str = location.href; //取得整个地址栏
    var num = str.indexOf("?")
    str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

    var arr = str.split("&"); //各个参数放到数组里
    for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
            name = arr[i].substring(0, num);
            value = arr[i].substr(num + 1);
            this[name] = value;
        }
    }
}


instance.interceptors.request.use(
    (config) => {
        // micromessToken
        var Request = new UrlSearch(); //实例化
        if (window.location.href.indexOf("micromessToken") && Request.micromessToken) {
            config.headers['X-TOKEN'] = Request.micromessToken;
        }
        // do something before request is sent
        config.headers['X-CLIENT'] = 'H5CUS'
        config.headers['X-Referer'] = window.location.href
        config.headers['X-Host'] = window.location.host || document.domain
        config.headers['X-Url'] = window.location.href || document.domain
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        // config.headers['X-TOKEN'] = localStorage.getItem('X-TOKEN');
        return config
    },
    (error) => {
        // do something with request error
        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    (response) => {
        if (response.data && response.status === 200) {
            if (response.data.errorCode === 401) {
                Toast.clear();
                if (window.navigator.userAgent.indexOf('cxo2sukangbao') !== -1) {
                    let sendverificatCodeisAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
                    let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                    if (isAndroid) {
                        // window.android.JSToNative(JSON.stringify(params))
                        window.native.login();
                        return false;
                    } else {
                        window.webkit.messageHandlers.login.postMessage({})
                        return false;
                        // window.webkit.messageHandlers.JSToNative.postMessage(params)
                        // JSToNative(JSON.stringify(params))
                    }
                } else {
                    if (sessionStorage.getItem('go_cc') == 1) {
                        sessionStorage.setItem('go_cc', 2);
                        sessionStorage.setItem('goType', 1);
                    }
                    if (response.data.data) {
                        window.location.href = response.data.data
                        // window.location.href = '#/login'
                        return Promise.reject(new Error('login'))
                    }
                    // window.location.replace = '#/user/login';
                    VueRouter.replace('/user/login?redirect=' + window.location.href)
                }

                // router.push('/login')

                return Promise.reject(new Error('login'))
            } else if (response.data.errorCode == 404) {
                // VueRouter.push({ path: "/404" })
                VueRouter.push({ path: '/404' })
                console.log(VueRouter);
            }
            if (response.data.errorCode !== 0) {
                return Promise.resolve(response)
            }
            return Promise.resolve(response)
        }
    },
    error => {
        Toast.clear();
        Toast('系统错误，请稍后重试');
        // window.load();
        return error;
    }
)

Vue.prototype.$axios1 = {
    get(url, params = {}, errCb = false, contentType = null) {
        return new Promise((resolve, reject) => {
            instance.get(url, {
                params,
                'Content-Type': contentType
            })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((err) => {
                    if (err.errorMsg) {
                        Vue.prototype.$toast(err.errorMsg)
                    }
                    if (errCb) {
                        reject(err)
                    }
                })
        })
    },
    post(url, data = {}, headers = {}, errCb = false) {
        return new Promise((resolve, reject) => {
            instance.post(url, data, headers)
                .then((response) => {
                    resolve(response.data)
                }, (err) => {
                    if (err.errorMsg) {
                        Vue.prototype.$toast(err.errorMsg)
                    }
                    if (errCb) {
                        reject(err)
                    }
                })
        })
    }
}

export default instance